import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
// import {Auth} from "@/packages/auth";
import QueryMerchant from "@/packages/c2bModules/SasaPayQueryMerchant/view/QueryMerchant.vue";

const QueryMerchantRoutes =[
    {
        path: '/dashboard/products',
        component: DashboardLayout,
        children: [
            {
                path: 'query-merchant',
                component: QueryMerchant,
                name: "QueryMerchant",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default QueryMerchantRoutes;
